import React from "react";
import GATSBY_COMPILED_MDX from "/vercel/path0/content/posts/2020-12-17-idees-cadeaux-pour-les-passionnes-de-poules/index.mdx";
import PostComponent, {Head} from "../components/post";
PostComponent
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PostComponent, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export {Head};
const query = "2040642971";
